import React, { createContext, useContext, useState } from "react";

const FilterContext = createContext();

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilterContext must be used within a FilterProvider");
  }
  return context;
};

export const FilterProvider = ({ children }) => {
  const [isFilterSheetOpen, setIsFilterSheetOpen] = useState(false);

  const value = {
    isFilterSheetOpen,
    setIsFilterSheetOpen,
  };

  return (
    <FilterContext.Provider value={value}>
      {children}
    </FilterContext.Provider>
  );
}; 